import { createAction, props } from '@ngrx/store';
import { ActionCreatorProps, NotAllowedCheck } from '@ngrx/store';

export interface BaseApiActionProps {
  requestId?: string;
}

export const createFailureAction = (type: string) =>
  createAction(type, props<{ requestId?: string; error: any }>());

export const createApiActions = <S extends BaseApiActionProps, T extends BaseApiActionProps>(
  baseType: string,
  initialProps: ActionCreatorProps<S> & NotAllowedCheck<S>,
  successProps: ActionCreatorProps<T> & NotAllowedCheck<T>,
) => ({
  baseAction: createAction(baseType, initialProps),
  successAction: createAction(`${baseType}_SUCCESS`, successProps),
  failureAction: createFailureAction(`${baseType}_FAILURE`),
});

export const createApiActionsWithoutInitialProps = <T extends BaseApiActionProps>(
  baseType: string,
  successProps: ActionCreatorProps<T> & NotAllowedCheck<T>,
) => ({
  baseAction: createAction(baseType, props<{ requestId?: string }>()),
  successAction: createAction(`${baseType}_SUCCESS`, successProps),
  failureAction: createFailureAction(`${baseType}_FAILURE`),
});

export const createApiActionsWithoutProps = (baseType: string) => ({
  baseAction: createAction(baseType),
  successAction: createAction(`${baseType}_SUCCESS`),
  failureAction: createFailureAction(`${baseType}_FAILURE`),
});

export const createApiActionsWithoutSuccess = <S extends BaseApiActionProps>(
  baseType: string,
  initialProps: ActionCreatorProps<S> & NotAllowedCheck<S>,
) => ({
  baseAction: createAction(baseType, initialProps),
  failureAction: createFailureAction(`${baseType}_FAILURE`),
});
